import List from 'src/storage/list';
import moment from 'moment';

class AiModel extends List {
  id = 'allstats';
  defaultState = () => ({
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'week_earnings',
      desc: true
    },
    startDate: moment().utc().startOf('isoWeek'),
    endDate: moment().endOf('day').utc(),
    prompt:
      "Your name is Life Robot. You're an AI assistant for LifeApp, an app for connecting users with doctors to help with their problems. English language is supported by default."
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    refresh: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy.key,
      sortDesc: !!this.state.sortBy.desc
    };
    let startDate = this.input('startDate');
    if (startDate) {
      req.startDate = parseInt(startDate.clone().startOf('day').utc().valueOf());
    }
    let endDate = this.input('endDate');
    if (endDate) {
      req.endDate = parseInt(endDate.clone().endOf('day').utc().valueOf());
    }
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  getTotalData = (prefix, field) => {
    let items = this.items();
    let result = 0;
    items.forEach((item) => {
      if (item[prefix + '_' + field] > 0) result += item[prefix + '_' + field];
    });
    if (result.toString().split('.')[1]?.length > 2) result = result.toFixed(2);
    return result;
  };
}

const model = new AiModel();
export default model;
